class CC_Notifications {
    constructor(notificationsJson, options = {}){
        this.options = Object.assign(
            {},
            {    
                config: ""
            }, 
            options
        );    

        //Variables  
        this.notifications = notificationsJson.notifications; 
        this.notifications_count = notificationsJson.notifications_count;  
        this.contentNotificationsFront = document.querySelector("#notifs #notifications .content-notifications");
        this.contentPictoNotificationsCount = document.querySelector("#notifs .content-picto-notifs .count");
        this.contentNotifPicto = document.querySelector("#notifs .content-picto-notifs");
        this.closeNotifs = document.querySelector("#notifs #notifications .close-notifications"); 
        if(this.contentNotificationsFront != null){
            this.buildNotifications(this.notifications); 

            this.contentNotifPicto.addEventListener("click", () => {
                this.contentNotifPicto.closest("#notifs").classList.toggle("open");
                //this.contentPictoNotificationsCount.classList.add("off");
            });

            this.closeNotifs.addEventListener("click", () => {
                this.contentNotifPicto.closest("#notifs").classList.toggle("open"); 
            });

            this.contentNotificationsFront.querySelectorAll(".notification").forEach(notif => { 
                notif.addEventListener("click", (e) => {
                    e.preventDefault();
                    let id = notif.getAttribute("data-id");
                    let href = notif.getAttribute("href");
                    this.updateCookieNotif(id); 
                    window.location.href = href;
                }); 
            }); 
        } 
    }  

    removeAccents(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');  // Retire les accents
    }

    buildNotifications(notifs){ 
        let arImage = [];
        var checkCookie = this.checkCookie(); 
        let arNotifsOpen = checkCookie != "" ? checkCookie.split(",") : [];
        let notifToShowCount = 0;
        notifs.forEach(notif => {
            let contentNotif = this.createElementWithClass("a", "notification");
            contentNotif.href = notif.url;
            let id_notif = this.removeAccents(notif.desc)
            .replace("<p>", "")
            .replace("</p>", "")
            .substring(0, 20)             // Récupère les 20 premiers caractères (ou moins si la chaîne est plus courte)
            .toLowerCase()                // Met tout en minuscule
            .replace(/\s+/g, '_')         // Remplace tous les espaces par des underscores
            .replace(/[^a-z0-9_]/g, '');
            contentNotif.setAttribute("data-id", id_notif);
            let contentNotifImg = this.createElementWithClass("div", "content-img");
            let imgNotif = this.createElementWithClass("img", "img-notif");
            imgNotif.classList.add("lazy");
            imgNotif.classList.add("ext");
            imgNotif.setAttribute("data-src", notif.img);
            imgNotif.setAttribute("alt", contentNotif);
            contentNotifImg.appendChild(imgNotif);
            let contentNotifDesc = this.createElementWithClass("div", "content-desc");
            contentNotifDesc.innerHTML = notif.desc;
            contentNotif.appendChild(contentNotifImg);  
            contentNotif.appendChild(contentNotifDesc); 
            this.contentNotificationsFront.appendChild(contentNotif); 
            arImage.push(imgNotif); 
            if(!arNotifsOpen.includes(id_notif)){
                contentNotif.classList.add("focus");
                notifToShowCount++;
            }
        }); 
        new LazyLoader(arImage);
        this.notifToShow(notifToShowCount);
    }

    notifToShow(nb){  
        if(nb > 0){
            this.contentPictoNotificationsCount.textContent = nb; 
            this.contentPictoNotificationsCount.classList.remove("off");
        }else{
            this.contentPictoNotificationsCount.textContent = "";
            this.contentPictoNotificationsCount.classList.add("off");
        } 
    }

    updateCookieNotif(label){ 
        let checkCookie = this.checkCookie();
        let labelToPush = checkCookie += label + ","; 
        this.setCookie("notifications", labelToPush, 30);
    }

    checkCookie(){
        if(this.getCookie("notifications") != null){
            return this.getCookie("notifications");
        }else{
            return "";
        }
    }

    createElementWithClass(type, className){
        var element = document.createElement(type);
        element.classList.add(className);
        return element;
    }

    deleteCookie(name){ 
        document.cookie = name + "= ; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/";
    } 
    
    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    
    setCookie(name,value,days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days*24*60*60*1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }  

     
} 